import { auth, db, storage } from "../../../firebaseConfig"; // Ensure you have storage imported from your Firebase configuration
import { doc, setDoc, getDoc } from "firebase/firestore";
import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import { getSelectedUid } from "../../../../frontend/Recruitment/Applications/Utils/UidListener";

// Function to save form data for Section 6
const uploadFileToStorage = async (file) => {
  const userId = getSelectedUid(); // Get the selected UID
  if (!userId) {
    throw new Error("Invalid user.");
  }
  const storageRef = ref(
    storage,
    `uploads/${userId}/ApplicationDetails/Section6/${file.name}`
  );
  await uploadBytes(storageRef, file);
  const downloadURL = await getDownloadURL(storageRef);
  return downloadURL;
};

const deleteFileFromStorage = async (fileName) => {
  // console.log(`Deleting file: ${fileName}`);
  const userId = getSelectedUid(); // Get the selected UID
  if (!userId) {
    throw new Error("Invalid user.");
  }
  try {
    const fileRef = ref(
      storage,
      `uploads/${userId}/ApplicationDetails/Section6/${fileName}`
    );
    await deleteObject(fileRef); // Delete the file from Firebase Storage
    // console.log(`Deleted file: ${fileName}`);
  } catch (error) {
    // console.error(`Error deleting file: ${fileName}`, error);
  }
};

export const writeDataS6 = async (formData) => {
  const userId = getSelectedUid(); // Get the selected UID
  if (!userId) {
    throw new Error("Invalid user.");
  }
  try {
    const docRef = doc(
      db,
      "Advisers",
      userId,
      "Application Details",
      "Business Conduct"
    );

    const docSnap = await getDoc(docRef);
    let previouslySavedFiles = [];
    if (docSnap.exists()) {
      const previousData = docSnap.data();
      previouslySavedFiles = previousData.files || [];
    }

    const filesToDelete = previouslySavedFiles.filter(
      (previousFile) =>
        !formData.files.some(
          (currentFile) =>
            // Ensure comparison of both uploaded and saved files
            typeof currentFile === "object"
              ? currentFile.name === previousFile.name // For new file objects
              : currentFile.url === previousFile.url // For already uploaded files with URLs
        )
    );

    await Promise.all(
      filesToDelete.map(async (file) => {
        await deleteFileFromStorage(file.name); // Delete each file from Firebase Storage
      })
    );

    const uploadedFileUrls = await Promise.all(
      formData.files.map(async (file) => {
        // Only upload new files (not already saved)
        if (typeof file === "object") {
          const fileUrl = await uploadFileToStorage(file);
          return { name: file.name, url: fileUrl };
        } else {
          return file; // Keep already uploaded file URLs
        }
      })
    );

    const dataToSave = {
      ...formData,
      files: uploadedFileUrls, // Replace the files array with file URLs
    };

    await setDoc(
      docRef,
      {
        ...dataToSave,
      },
      { merge: true }
    );
  } catch (error) {
    // console.error("Error writing Section 5 data to Firestore: ", error);
  }
};
